// A list of overlay types.  Values are the keys used in other OverlayType-related objects.
export const OverlayType = {
  radar: 'radar',
  futureRadar: 'futureRadar',
  lightning: 'lightning',
  alerts: 'alerts',
  severeAlerts: 'severeAlerts',
  satellite: 'satellite',
  temperature: 'temperature',
  feelsLike: 'feelsLike',
  wind: 'wind',
  breathingIndex: 'breathingIndex',
} as const;

// Provides metadata and configuration values for each of the OverlayTypes.
export const OverlayTypeInfo = {
  [OverlayType.radar]: {
    inventoryKey: 'radar',
    shouldAnimate: true,
    waitForLoad: false,
    changeMapSelectable: true,
    parentOverlayType: null,
  },
  [OverlayType.futureRadar]: {
    inventoryKey: 'radarFcst',
    shouldAnimate: true,
    waitForLoad: false,
    changeMapSelectable: true,
    parentOverlayType: null,
  },
  [OverlayType.lightning]: {
    inventoryKey: 'radar',
    shouldAnimate: true,
    waitForLoad: false,
    changeMapSelectable: false,
    parentOverlayType: OverlayType.radar,
  },
  [OverlayType.alerts]: {
    inventoryKey: 'radar', // temporarily setting this to radar so it doesn't crash when Active Alerts selected (allows legend to be viewable for alerts)
    shouldAnimate: false,
    waitForLoad: true,
    changeMapSelectable: true,
    parentOverlayType: null,
  },
  [OverlayType.severeAlerts]: {
    inventoryKey: 'radar', // temporarily setting this to radar so it doesn't crash when Active Alerts selected (allows legend to be viewable for alerts)
    shouldAnimate: false,
    waitForLoad: false,
    changeMapSelectable: false,
    parentOverlayType: null,
  },
  [OverlayType.satellite]: {
    inventoryKey: 'sat',
    shouldAnimate: true,
    waitForLoad: false,
    changeMapSelectable: true,
    parentOverlayType: null,
  },
  [OverlayType.temperature]: {
    inventoryKey: 'temp',
    shouldAnimate: false,
    waitForLoad: true,
    changeMapSelectable: true,
    parentOverlayType: null,
    griddedProductNumber: 49,
    griddedVariableID: 'Temperatureheightaboveground',
  },
  [OverlayType.feelsLike]: {
    inventoryKey: 'feelsLike',
    shouldAnimate: false,
    waitForLoad: true,
    changeMapSelectable: true,
    parentOverlayType: null,
    griddedProductNumber: 60,
    griddedVariableID: 'VAR00198FROM25501heightaboveground',
  },
  [OverlayType.wind]: {
    inventoryKey: 'windSpeed',
    shouldAnimate: false,
    waitForLoad: true,
    changeMapSelectable: true,
    parentOverlayType: null,
    griddedProductNumber: 59,
    griddedVariableID: 'Windspeedheightaboveground',
  },
  [OverlayType.breathingIndex]: {
    inventoryKey: 'breathingFcst',
    shouldAnimate: false,
    waitForLoad: false,
    changeMapSelectable: true,
    parentOverlayType: null,
  },
};

// Provides a zoom preset, which is selectable by the user in the Map Type modal.
export const ZoomPreset = {
  local: 'local',
  regional: 'regional',
  national: 'national',
} as const;
